import React, {useContext, useEffect, useState} from "react";
import RatingComp from "../../../../../components/Multiple/RatingComp";
import ThemeContext from "../../../../../Context/theme/ThemeContext";
import axios from "axios";
import {BaseURL} from "../../../../../Files/BaseURL";
import {useParams} from "react-router-dom";

const AllReview = () => {
  const { theme } = useContext(ThemeContext);
  const [reviews, setReviews] = useState([]);
  const {userId} = useParams();

    const getReviews = async () => {
        try{
            const result = await axios.get(`${BaseURL}/api/review/getReviews/${userId}`, {
                headers: {
                    'auth-token': localStorage.getItem('p@token')
                }
            })
          
            if(result.status === 200){
                setReviews(result.data)
                
            }
        }
        catch (error){
            console.log(error)
        }
    }


    useEffect(() => {
        getReviews()
    },[userId])

    return (
    <div className="w-[95%] m-auto py-6">
      <div className="flex flex-col gap-4 font-pop">
        <h2 className="text-xl font-semibold ">
          All reviews about {reviews[0]?.reviewedTo.FirstName} {reviews[0]?.reviewedTo.LastName}
        </h2>
        <p className={`text-lightGrey ${theme == "dark" && "text-white"}`}>
            {reviews.length} Reviews
        </p>
      </div>
      <div className="flex flex-col gap-4">
          { reviews && reviews?.map((item, index) => ( <div className={`  py-4  px-4 rounded-2xl ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}>
              <RatingComp key={index} FirstName={item?.reviewedBy.FirstName} LastName={item?.reviewedBy.LastName}
                       ProfileImage={item?.reviewedBy.ProfilePhoto} Country={item?.reviewedBy.Homeaddress.Country}
                       rating={item?.rating} reviewMessage={item?.review} date={item?.date}/>
          </div>))}
      </div>
    </div>
              );
          };

          export default AllReview;
